import { TextField } from "@mui/material";
import React, { useState } from "react";
import { IMultitextInput } from "../../constants/model-interfaces";

const MultitextField = (props: IProps) => {
    const [value, setValue] = useState(props.input.value);
    return (
        <div className={"col-" + props.input.width}>
            <TextField
                className={props.input.isReadonly ? "meta-readonly" : ""}
                fullWidth
                type='text'
                inputProps={{
                    readOnly: props.input.isReadonly,
                    maxLength: props.input.chars
                }}
                placeholder={props.placeholder}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                onBlur={() => {
                    props.update(value);
                }}
            />
        </div>
    );
};

interface IProps {
    input: IMultitextInput;
    placeholder: string | undefined;
    update: Function;
}

export default MultitextField;
